export enum PageView {
  CHART = "CHART",
  LIST = "LIST"
}

export enum ReportTypes {
  HEADLINE_PAY_EQUITY_STATISTICS = "HEADLINE_PAY_EQUITY_STATISTICS",
  PAY_EQUITY_BY_JOB_LEVEL = "PAY_EQUITY_BY_JOB_LEVEL",
  VARIABLE_PAY_REPORTING = "VARIABLE_PAY_REPORTING",
  REWARD_BENCHMARK = "REWARD_BENCHMARK"
}

export enum ControlType {
  GROUP_MULTI_SELECT = "GroupMultiSelect",
  MULTI_SELECT = "MultiSelect",
  SINGLE_SELECT = "SingleSelect",
  MULTIPLE_INPUT = "MultipleInput",
  NUMERIC = "Numeric",
  TEXT = "Text",
  SLIDERINPUT = "SliderInput"
}

export enum ReportTab {
  CONFIG = 0,
  MARKET_FILTERS = 1,
  ORG_FILTERS = 2,
  DOWNLOD_REPORT = 3
}

export enum FilterType {
  CONFIG = "CFG",
  MARKET = "MARKET",
  ORGANIZATION = "ORG",
  EXPORT = "Modelling"
}

export enum HttpCodes {
  SUCCESS = 200,
  SUCCESS_204 = 204,
  POST_SUCCESS = 201,
  BAD_REQUEST = "400",
  UNAUTHORIZED = "401",
  FORBIDDEN = "403",
  INTERNAL_SERVER_ERROR = "500"
}

export enum DataTypes {
  STRING = "string",
  NUMBER = "number",
  BOOLEAN = "boolean",
  ARRAY = "array",
  OBJECT = "object",
  DATE = "date"
}

export const PayAnalyticsConstants = {
  ORGVSMARKET: "MRKVSCLIENT"
};


export const BasicPackagesIds = [2,16];
export const ParticpantPackagesIds = [17,50];
export const PremiumPackagesIds = [1,15];